<template>
    <div class="boxContentMessageContainer">
        <div class="container iconContainer">
            <slot name="icon"></slot>
        </div>
        <div class="container titleMedium">
            <slot name="primaryText"></slot>
        </div>
        <div class="container webBody secondaryTextContainer">
            <slot name="secondaryText"></slot>
        </div>
        <div class="container webBody secondaryTextAdditionalContainer">
            <slot name="secondaryTextAdditional"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'boxContentMessage',
    data() {
        return {};
    }
};
</script>
<style scoped lang="scss">
@import "~styles/styleGuide.V2";

.boxContentMessageContainer {
    color: $dark-500;

    .container {
        display: grid;
        place-items: center;

        div {
            text-align: center;
        }
    }

    .iconContainer {
        padding-top: 12px;
        width: 100%;
        height: 209px;
    }

    .secondaryTextContainer {
        padding-top: 18px;
    }

    .secondaryTextAdditionalContainer {
        padding-top: 32px;
        padding-bottom: 48px;
    }
}
</style>
